<template>
  <div id="ios-redirect"></div>
</template>

<script>
export default {
  name: "ios-redirect",
  mounted() {
    window.location.href =
      "https://apps.apple.com/cz/app/easi-score/id1538156043";
  }
};
</script>
